import { version as reactVersion } from 'react';
import { FetchPriority, ObjectFit, WithFetchPriority } from './types';
import { State } from './enums';
import css from './style.module.css';

export const rootStatePresets: Record<State, Maybe<string>> = {
  [State.LOADED]: css.transparent,
  [State.FAILED]: undefined,
  [State.LOADING]: undefined,
  [State.PLACEHOLDER]: undefined,
};

export const imageStatePresets: Record<State, Maybe<string>> = {
  [State.LOADED]: css.visible,
  [State.FAILED]: undefined,
  [State.LOADING]: undefined,
  [State.PLACEHOLDER]: undefined,
};

export const imageObjectFitPresets: Record<ObjectFit, string> = {
  contain: css.contain,
  cover: css.cover,
  none: css.none,
  'scale-down': css.scaleDown,
};

/**
 * Определяет правильное название пропа `fetchPriority` для `img`.
 * @description
 * - в React < 19 необходимо использовать `fetchpriority`
 * - в React 19+ необходимо использовать `fetchPriority`
 */
export const getFetchPriorityProp = (
  value: FetchPriority
): WithFetchPriority =>
  reactVersion.startsWith('19')
    ? { fetchPriority: value }
    : { fetchpriority: value };
